import { Modal } from '@stormwater-software/lib-ui';
import React, { useEffect, useState } from 'react';
import subscriptionApi from '../../../utils/api/subscription';
import SubscriptionCard from '../../Subscription/SubscriptionCard';
import Loading from '../../Shared/ResourceIndex/Loading';
import { useHistory } from 'react-router-dom';

export default function ChooseSubscriptionModal({
  isNew,
  setShowModal,
  role,
  canManageSubscription = false,
  subscriptionTenantQuery,
  currentTenantSubscriptionId,
}: {
  isNew: boolean;
  setShowModal: (show: boolean) => void;
  role: any;
  canManageSubscription?: boolean;
  subscriptionTenantQuery: any;
  currentTenantSubscriptionId?: number;
}) {
  const [subscriptions, setSubscriptions] = useState<any[]>([]);
  const [loader, setLoader] = useState<boolean>(false);
  const [currentSubscriptionIndex, setCurrentSubscriptionIndex] = useState(0);
  const history = useHistory();

  useEffect(() => {
    setLoader(true);
    if (role.name === 'Super Admin') {
      subscriptionApi.show().then((res) => {
        setSubscriptions(res);
        setLoader(false);
      });
    } else {
      subscriptionApi.showPublic().then((res) => {
        setSubscriptions(res);
        setLoader(false);
      });
    }
  }, []);

  const handleChoosePlan = (subscription_id: number) => {
    subscriptionApi.choosePlan(subscription_id).then(() => {
      subscriptionTenantQuery.refetch();
      setShowModal(false);
      history.go(0);
    });
  };

  const handleChangePlan = (newSubscriptionId: number) => {
    subscriptionApi
      .changePlan(currentTenantSubscriptionId!, newSubscriptionId)
      .then(() => {
        subscriptionTenantQuery.refetch();
        setShowModal(false);
        history.go(0);
      });
  };


  const onLeft = () => {
    if (currentSubscriptionIndex > 0) {
      setCurrentSubscriptionIndex(currentSubscriptionIndex - 1);
    }
  };

  const onRight = () => {
    if (currentSubscriptionIndex < subscriptions.length - 1) {
      setCurrentSubscriptionIndex(currentSubscriptionIndex + 1);
    }
  };

  if (isNew) {
    return (
      <Modal
        show={true}
        handleClose={() => setShowModal(false)}
        style={{
          padding: '0px',
          borderRadius: '10px',
          paddingBottom: '1rem',
          maxWidth: '60rem',
        }}
        submitBtnText={'Choose Plan'}
        handleSubmit={() => { handleChoosePlan(subscriptions[currentSubscriptionIndex].id) }}
        disableClose={true}
        cancelBtn={true}
      >
        {loader ? (
          <Loading />
        ) : (
          <>
            {subscriptions.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '1rem' }}>
                No subscription found
              </div>
            ) : (
              <>
                <SubscriptionCard
                  name={subscriptions[currentSubscriptionIndex].name}
                  description={
                    subscriptions[currentSubscriptionIndex].description
                  }
                  price={subscriptions[currentSubscriptionIndex].price}
                  addOnList={subscriptions[currentSubscriptionIndex].addons}
                  subscriptionType={
                    subscriptions[currentSubscriptionIndex].subscription_type
                  }
                  type={'choose'}
                />
                <div className='choose-subscription-button-container'>
                  <button
                    className='choose-subscription-button'
                    onClick={() => onLeft()}
                    disabled={currentSubscriptionIndex === 0}
                  >
                    <i className='fa fa-chevron-left'></i>
                  </button>
                  <button
                    className='choose-subscription-button'
                    onClick={() => onRight()}
                    disabled={
                      currentSubscriptionIndex === subscriptions.length - 1
                    }
                  >
                    <i className='fa fa-chevron-right'></i>
                  </button>
                </div>
              </>
            )}
          </>
        )}
      </Modal>
    )
  }

  if (canManageSubscription) {
    return (
      <Modal
        show={true}
        handleClose={() => setShowModal(false)}
        style={{
          padding: '0px',
          borderRadius: '10px',
          paddingBottom: '1rem',
          maxWidth: '60rem',
        }}
        submitBtnText={'Change Plan'}
        handleSubmit={() => handleChangePlan(subscriptions[currentSubscriptionIndex].id)}
        disableClose={true}
        cancelBtn={true}
      >
        {loader ? (
          <Loading />
        ) : (
          <>
            {subscriptions.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '1rem' }}>
                No subscription found
              </div>
            ) : (
              <>
                <SubscriptionCard
                  name={subscriptions[currentSubscriptionIndex].name}
                  description={subscriptions[currentSubscriptionIndex].description}
                  price={subscriptions[currentSubscriptionIndex].price}
                  addOnList={subscriptions[currentSubscriptionIndex].addons}
                  subscriptionType={subscriptions[currentSubscriptionIndex].subscription_type}
                  type={'choose'}
                />
                <div className='choose-subscription-button-container'>
                  <button
                    className='choose-subscription-button'
                    onClick={() => onLeft()}
                    disabled={currentSubscriptionIndex === 0}
                  >
                    <i className='fa fa-chevron-left'></i>
                  </button>
                  <button
                    className='choose-subscription-button'
                    onClick={() => onRight()}
                    disabled={currentSubscriptionIndex === subscriptions.length - 1}
                  >
                    <i className='fa fa-chevron-right'></i>
                  </button>
                </div>
              </>
            )}
          </>
        )}
      </Modal>
    );
  }

  return (
    <Modal
      show={true}
      handleClose={() => setShowModal(false)}
      title={`Need to update your subscription?`}
      handleSubmit={() => setShowModal(false)}
      submitBtnText='Ok'
    >
      <p>Plan-change self-service is coming soon. For now, please email our <i>
        <u>
          <a
            href="mailto:support@sw2.net"
            style={{ color: "inherit", textDecoration: "underline" }}
          >
            <strong>subscription specialist</strong>
          </a>
        </u>
      </i> (or call 1-720-456-2420) and we'll be happy to adjust your plan for you.</p>
    </Modal>
  )
}
